import styled from '@emotion/styled';

export const LaunchButton = styled.button`
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 1200;
  border: none;
  border-radius: 24px;
  padding: 12px 18px;
  background: #f08421;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;

  &:hover {
    background: #eb8e21;
  }
`;

export const Rail = styled.aside`
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1300;
  width: 360px;
  max-width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-left: 1px solid #e6e8eb;
  box-sizing: border-box;
  overflow: hidden;
`;

export const RailHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 16px 12px;
  border-bottom: 1px solid #eceff2;
  background: #0b315e;
  color: #ffffff;
`;

export const RailTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
`;

export const RailSubtitle = styled.div`
  margin-top: 4px;
  font-size: 12px;
  opacity: 0.85;
`;

export const CloseButton = styled.button`
  border: none;
  background: transparent;
  color: #ffffff;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  padding: 0 4px;
`;

export const Checklist = styled.ol`
  list-style: none;
  margin: 0;
  padding: 12px 16px;
  display: grid;
  gap: 6px;
  background: #f9f9f9;
  border-bottom: 1px solid #eceff2;
`;

export const ChecklistItem = styled.li`
  font-size: 12px;
  color: ${(props) => {
    if (props.done) {
      return '#4caf50';
    }
    if (props.active) {
      return '#f08421';
    }
    return '#8b9096';
  }};
  font-weight: ${(props) => (props.active ? 600 : 500)};
`;

export const Messages = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: #f7f8fa;
`;

export const Bubble = styled.div`
  max-width: 90%;
  align-self: ${(props) => (props.role === 'user' ? 'flex-end' : 'flex-start')};
  background: ${(props) => (props.role === 'user' ? '#0b315e' : '#ffffff')};
  color: ${(props) => (props.role === 'user' ? '#ffffff' : '#333333')};
  border: ${(props) => (props.role === 'user' ? 'none' : '1px solid #e6e8eb')};
  border-radius: 12px;
  padding: 10px 12px;
  font-size: 13px;
  line-height: 1.45;
  white-space: pre-wrap;
`;

export const QuickActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 10px 16px;
  border-top: 1px solid #eceff2;
  background: #ffffff;
  box-sizing: border-box;
  max-width: 100%;
`;

export const Chip = styled.button`
  border: 1px solid #f08421;
  background: #fff8f0;
  color: #c45f00;
  border-radius: 16px;
  padding: 6px 10px;
  font-size: 12px;
  cursor: pointer;
  font-family: inherit;
  max-width: 100%;
  box-sizing: border-box;
  white-space: normal;
  text-align: left;

  &:hover {
    background: #ffefd9;
  }
`;

export const Composer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: 100%;
  padding: 12px 16px 16px;
  border-top: 1px solid #eceff2;
  background: #ffffff;
  box-sizing: border-box;
`;

export const Input = styled.input`
  display: block;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  border: 1px solid #d7dbe0;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 13px;
  font-family: inherit;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #f08421;
  }
`;

export const SendButton = styled.button`
  display: block;
  width: 100%;
  border: none;
  border-radius: 8px;
  padding: 10px 14px;
  background: #f08421;
  color: #ffffff;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  font-family: inherit;
  white-space: nowrap;
  box-sizing: border-box;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
